module.exports = __webpack_public_path__ + "img/complaint-email.2be97bc8.png";